import { useEffect } from "react";
import axios from "utils/axios";
import useAuth from "hooks/useAuth";
import { isSubAdmin } from "utils/adminAccess";

const HEARTBEAT_MS = 45_000;

/**
 * Keeps sub-admin presence as "online" while the admin layout is mounted.
 */
export default function useSubAdminPresence() {
  const { user, isLoggedIn } = useAuth();
  const subAdmin = isSubAdmin(user);

  useEffect(() => {
    if (!isLoggedIn || !subAdmin) return undefined;

    const sendHeartbeat = () => {
      axios.post("/api/users/sub-admins/presence/heartbeat/").catch(() => {});
    };

    sendHeartbeat();
    const intervalId = window.setInterval(sendHeartbeat, HEARTBEAT_MS);

    return () => window.clearInterval(intervalId);
  }, [isLoggedIn, subAdmin]);
}
